import { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const links = [
  { to: '/', label: 'Контролна табла' },
  { to: '/explore', label: 'Истражување' },
  { to: '/alerts', label: 'Предупредувања' },
  { to: '/admin', label: 'Администрација' }
];

function Navigation() {
  const { user, logout, isGuest } = useAuth();
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const handleSearch = (e) => {
    if (e.key === 'Enter') {
      navigate(`/explore?search=${encodeURIComponent(searchTerm)}`);
      setSearchTerm(''); // Optional: clear after search
      closeMenu();
    }
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
    closeMenu();
  };

  const handleLogin = () => {
    navigate('/login');
    closeMenu();
  };

  const handleProfileClick = () => {
    navigate('/profile');
    closeMenu();
  };

  const getUserInitials = () => {
    if (user?.first_name && user?.last_name) {
      return `${user.first_name.charAt(0)}${user.last_name.charAt(0)}`.toUpperCase();
    } else if (user?.first_name) {
      return user.first_name.charAt(0).toUpperCase();
    } else if (user?.username) {
      return user.username.charAt(0).toUpperCase();
    }
    return 'U';
  };

  return (
      <header className="navigation">
        <div className="nav-brand-row">
          <div className="brand">
            Crypto<span className="brand-accent">Vision</span>
          </div>

          <div className="nav-brand-actions">
            {!isGuest && (
                <div
                    className="avatar avatar-mobile"
                    title={`${user?.first_name || ''} ${user?.last_name || ''}`.trim() || user?.username || 'User'}
                    onClick={handleProfileClick}
                    style={{cursor: 'pointer'}}
                >
                  {getUserInitials()}
                </div>
            )}

            <button className="burger-btn" onClick={toggleMenu} aria-label="Toggle menu">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                   strokeLinecap="round" strokeLinejoin="round">
                {isMenuOpen ? <path d="M18 6L6 18M6 6l12 12"/> : <path d="M3 12h18M3 6h18M3 18h18"/>}
              </svg>
            </button>
          </div>
        </div>

        <div className={`nav-content ${isMenuOpen ? 'open' : ''}`}>
          <nav className="navigation-links">
            {links.map((link) => {
              if (link.to === '/admin' && !user?.is_admin) return null;
              return (
                  <NavLink
                      key={link.to}
                      to={link.to}
                      className={({isActive}) =>
                          isActive ? 'nav-link nav-link-active' : 'nav-link'
                      }
                      end={link.to === '/'}
                      onClick={closeMenu}
                  >
                    {link.label}
                  </NavLink>
              );
            })}
          </nav>
          <div className="navigation-actions">
            <div className="search">
              <input
                  type="text"
                  placeholder="Пребарај активи"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  onKeyDown={handleSearch}
              />
            </div>
            {isGuest ? (
                <>
                  <button className="button button-outline" onClick={handleLogin}>
                    Најави се
                  </button>
                </>
            ) : (
                <>
                  <div
                      className="avatar"
                      title={`${user?.first_name || ''} ${user?.last_name || ''}`.trim() || user?.username || 'User'}
                      onClick={handleProfileClick}
                      style={{cursor: 'pointer'}}
                  >
                    {getUserInitials()}
                  </div>
                  {!isGuest && (
                      <button
                          className="button button-outline logout-button"
                          onClick={handleLogout}
                      >
                        Одјави се
                      </button>
                  )}
                </>
            )}
          </div>
        </div>
      </header>
  );
}

export default Navigation;

